import {StorageEnum} from "./storage.enum";
import {StorageService} from "./storage.service";

export class StorageItem<T> {
  private readonly key: string;
  private readonly value: T;
  private storage: StorageEnum | undefined;
  private expireInSeconds: number | undefined;

  constructor(key: string, value: T) {
    this.key = key;
    this.value = value;
  }

  public inStorage(storage: StorageEnum): StorageItem<T> {
    this.storage = storage;
    return this;
  }

  public withExpire(expireInSeconds: number): StorageItem<T> {
    this.expireInSeconds = expireInSeconds;
    return this;
  }

  public withoutExpire(): StorageItem<T> {
    return this.withExpire(StorageService.EXPIRE_UNLIMITED);
  }

  public getKey(): string {
    return this.key;
  }

  public getValue(): T {
    return this.value;
  }

  public getStorage(): StorageEnum | undefined {
    return this.storage;
  }

  public getExpire(): number | undefined {
    return this.expireInSeconds;
  }
}
